var _rect, _rect2, _rect3, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "173.58 160.383 30 30",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 197.58,
    y: 181.383,
    width: 2,
    height: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.58,
    y: 176.383,
    width: 2,
    height: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 189.58,
    y: 178.383,
    width: 2,
    height: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 201.58 162.383 L 177.58 162.383 C 176.476 162.384 175.581 163.279 175.58 164.383 L 175.58 176.383 L 177.58 176.383 L 177.58 173.383 L 201.581 173.383 L 201.582 188.383 L 189.58 188.383 L 189.58 190.383 L 201.58 190.383 C 202.684 190.382 203.579 189.487 203.58 188.383 L 203.58 164.383 C 203.579 163.279 202.684 162.384 201.58 162.383 Z M 185.58 171.383 L 177.58 171.383 L 177.58 164.383 L 185.58 164.383 L 185.58 171.383 Z M 187.58 171.383 L 187.58 164.383 L 201.58 164.383 L 201.581 171.383 L 187.58 171.383 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    },
    x: 173.58,
    y: 160.383
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "185.602 184.388 181.602 184.388 181.602 180.388 179.602 180.388 179.602 184.388 175.602 184.388 175.602 186.388 179.602 186.388 179.602 190.388 181.602 190.388 181.602 186.388 185.602 186.388 185.602 184.388"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCopyIcon);
export default __webpack_public_path__ + "static/media/DashboardCopyIcon.5d8c70a70e102d0e4643502e7b42f5e8.svg";
export { ForwardRef as ReactComponent };